/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Server-resolved identity filters; browsers never provide an email.
 */
export enum RoadmapDependencyIdentitySelector {
    ALL = 'all',
    ME = 'me',
}
